import * as types from './LoginActionType';

export const loginRequest = data => ({
    type: types.LOGIN_REQUEST,
    payload: data,
});
export const loginSuccess = data => ({
    type: types.LOGIN_SUCCESS,
    payload: data,
});
export const loginFailure = data => ({
    type: types.LOGIN_FAILURE,
    payload: data,
});

export const logoutRequest = data => ({
    type: types.LOGOUT_REQUEST,
    payload: data,
});
export const logoutSuccess = data => ({
    type: types.LOGOUT_SUCCESS,
    payload: data,
});
export const logoutFailure = data => ({
    type: types.LOGOUT_FAILURE,
    payload: data,
});

export const noAccess = (data) => ({
    type: types.NO_ACCESS,
    payload: data,
});

export const resetNoAccess = () => ({
    type: types.RESET_NO_ACCESS
});